import { useState } from "react";
import { Button } from "@/components/ui/button";
import type { EchoflicksSessionRemake } from "../types";
import { remakeVideoSource } from "./remakePlayback";
import { useMediaUrl } from "./useMediaUrl";

export function RemakeVideoPlayer({
  remake,
}: {
  remake: EchoflicksSessionRemake;
}) {
  const source = remakeVideoSource(remake);
  const preview = useMediaUrl(source);
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const failed =
    preview.status === "error" ||
    Boolean(preview.url && failedUrl === preview.url);

  if (!source) {
    return (
      <p className="text-sm text-muted-foreground">
        No video is recorded for this remake.
      </p>
    );
  }

  return (
    <div className="space-y-2">
      <div className="overflow-hidden rounded-md bg-black">
        {preview.url ? (
          <video
            aria-label={`Remake video ${remake.id}`}
            src={preview.url}
            controls
            playsInline
            preload="metadata"
            onError={() => setFailedUrl(preview.url)}
            className="aspect-video max-h-[70vh] w-full bg-black"
          />
        ) : !failed ? (
          <p className="p-6 text-sm text-white/70">
            Preparing a private remake video…
          </p>
        ) : null}
      </div>
      {failed ? (
        <div role="alert" className="space-y-2">
          <p className="text-sm text-destructive">
            {preview.error ||
              "The remake video could not be loaded. Reload it to renew its private link."}
          </p>
          <Button
            type="button"
            variant="outline"
            size="sm"
            disabled={preview.isLoading}
            onClick={() => {
              setFailedUrl(null);
              preview.refresh();
            }}
          >
            Reload remake video
          </Button>
        </div>
      ) : null}
    </div>
  );
}
